export enum Role {
  PowerUser = 'power_user',
  Admin = 'admin',
  User = 'user',
  Unknown = 'unknown',
  Anonymous = 'anonymous',
}

export enum PermissionResolver {
  US = 'US',
}

export enum AppVersion {
  'Unknown' = 'Unknown',
  'US' = 'US',
  'Test_US' = 'Test_US',
}

export interface FirebaseTokenCustomClaims {
  app: AppVersion
  email: string
  role: Role
  roles: string[]
}
